import CustomAxiosInstance from "../middlewares/axios/connectionErrorMiddleware";
import { authEndpoints } from "../helpers/requests/apiEndpoints";

const api = CustomAxiosInstance();

const methods = {
  register: (payload) =>
    api.post(authEndpoints.registerUrl, payload).then((res) => {
      const responseData = res.data;
      api.defaults.headers.common["Authorization"] =
        `Bearer ${responseData.token}`;
      return responseData;
    }),
  login: (payload) =>
    api.post(authEndpoints.loginUrl, payload).then((res) => res.data),
};

export default methods;
